import React, { useRef } from "react";
// import ErrorModal from "./errorModal";

const ShareData = ({ className = "", children, data }) => {
  // const errorModalRef = useRef(null);

  const handleShare = async () => {
    await navigator.share(data).catch((/* error */) => {
      // errorModalRef.current?.showModal();
      // throw error;
    });
  };

  // const handleHideErrorModal = () => {
  //   errorModalRef.current?.hideModal();
  // };

  if (!navigator.canShare) return;

  return (
    <>
      <button className={className} onClick={handleShare}>
        {children}
      </button>
      {/* <ErrorModal
        title={"share"}
        description={"sharing-not-supported"}
        errorModalRef={errorModalRef}
        onClick={handleHideErrorModal}
      /> */}
    </>
  );
};

export default ShareData;
